module.exports = __webpack_public_path__ + "img/menzroom.8c83b3c2.jpg";